import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import { shouldFacetBeShown } from "../../../../../../common/utils/filters";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import Facet from "./Facet";
export default class Facets extends Component {
  render() {
    const facets = this.props.facets.filter(f => shouldFacetBeShown(f.get('key'), this.props.hiddenFilters));
    const forceFacetsExpanded = facets.size <= 2;
    return /*#__PURE__*/React.createElement("div", null, facets.map(facet => {
      return /*#__PURE__*/React.createElement(Facet, {
        forceExpanded: forceFacetsExpanded,
        facet: facet,
        filters: this.props.filters,
        filtersContext: this.props.filtersContext,
        filtersLink: this.props.filtersLink,
        hiddenFilters: this.props.hiddenFilters,
        key: "facet-".concat(facet.get('key')),
        perspective: this.props.perspective,
        stateChangeRequested: this.props.stateChangeRequested
      });
    }));
  }

}

_defineProperty(Facets, "propTypes", {
  facets: ImmutablePropTypes.list.isRequired,
  filters: CommonPropTypes.filters,
  filtersContext: AddonDiscoveryPropTypes.filtersContext,
  filtersLink: PropTypes.func.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});